import React, { useState, lazy, Suspense, useRef } from 'react';
import { useStyles } from '../components/Header/styles';
import clsx from 'clsx';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { Theme, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import * as Service from '../services';
import * as Constants from '../constants';
import { errorHandler, getItemStore, setItemStore } from '../Utilities/appHelpers';
import { getPatients } from '../services/Patient';
import LockScreen from '../LockScreen';
import Img from '../LockScreen/inactive.png';
import AuthenticatedRoutes from '../routes/authenticatedRoutes';

const AuthenticatedLayout = (props: any) => {
   const classes = useStyles();
   const theme: Theme = useTheme();
   const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
      defaultMatches: true,
   });
   const [mobileSidebarIsOpened, setMobileOpen] = useState<boolean>(false);
   const [sidebarIsOpened, setOpen] = useState<boolean>(true);
   const history = useHistory();
   const token = getItemStore('AUTOMEDSYS_TOKEN');
   const [patients, setPatients] = useState<Array<Record<string, any>>>([]);
   const [patientCharts, setPatientCharts] = useState<Array<Record<string, any>>>([]);

   const authenticated = token;

   React.useEffect(() => {
      if (!authenticated) {
         history.push('/');
      }
   }, [authenticated]);

   useEffect(() => {
      const fetchData = async () => {
         try {
            // const patientCharts = await Service.getListItems(Constants.CHARTS, Constants.CHARTS, 1, 10000, {});
            const patientCharts = await getPatients(Constants.PATIENTS, 1, 10000, { PatientQueryOption: 2 });
            const patients = await getPatients(Constants.PATIENTS, 1, 10000, {});
            const patientsList = patients.data.ResponseData.Items.map((item: Record<string, any>) => {
               return {
                  value: item.ChartNumber,
                  label: `${item.FirstName} ${item.LastName}`,
               };
            });
            const patientChartsList = patientCharts.data.ResponseData.Items.map((item: Record<string, any>) => {
               return {
                  value: item.ChartNumber,
                  label: `${item.FirstName} ${item.LastName}`,
               };
            });
            setPatients(patientsList);
            setPatientCharts(patientChartsList);
         } catch (err) {
            errorHandler(err);
         }
      };
      fetchData();
   }, []);

   const fetchGenders = async () => {
      const response = await Service.getItems(Constants.SYSTEMS, Constants.CONSTANTS, Constants.GENDER, {});

      if (response.status === 200) {
         setItemStore('genders', JSON.stringify(response.data.ResponseData));
      }
   };

   const fetchSubstitions = async () => {
      const response = await Service.getItems(Constants.SYSTEMS, Constants.LOOKUP, Constants.MSUBSTITUTIONS, {});

      if (response.status === 200) {
         setItemStore('substitutions', JSON.stringify(response.data.ResponseData));
      }
   };

   const fetchEnums = async () => {
      await Promise.all([fetchGenders(), fetchSubstitions()]);
   };

   useEffect(() => {
      fetchEnums();
   }, []);

   const openSidebar = () => {
      isDesktop ? setOpen(true) : setMobileOpen(true);
   };

   const closeSidebar = () => {
      isDesktop ? setOpen(!sidebarIsOpened) : setMobileOpen(!mobileSidebarIsOpened);
   };

   const viewPatient = (chartNo: string) => {
      history.push({
         pathname: `/patient/demography`,
         state: { data: chartNo },
      });
   };

   const viewPatientChart = (chartNo: string) => {
      history.push({
         pathname: `/patient/chart`,
         state: { data: chartNo },
      });
   };

   const searchFilters = [
      {
         label: 'Patients',
         lists: patients,
         action: viewPatient,
         route: '/patient/demography',
      },
      {
         label: 'Patients Charts',
         lists: patientCharts,
         action: viewPatientChart,
         route: '/patient/chart',
      },
   ];

   const user = {
      name: getItemStore('AUTOMEDSYS_USERNAME'),
      image: '',
      practiseLogo: null,
      practiseName: getItemStore('AUTOMEDSYS_PRACNAME'),
   };

   //Y=>Lockscreen Logic
   //************************************************ */
   //Determine if screen to be locked
   const [lockScreen, setLockScreen] = useState(false);
   const [anim, setAnim] = useState('fast fadeIn');
   const IdleT: string | null = getItemStore('AUTOMEDSYS_IDLE');

   // const delayTime: number = parseInt(.toString());
   //const delayTime = IdleT === null ? 200000 : parseInt(IdleT);
   const delayTime = IdleT === null ? 200000 : parseInt(IdleT) * 1000;
   //console.log(delayTime);
   //const delayTime = 600 * 1000;
   //console.log(delayTime);
   const timer: any = useRef();
   const monitorTimer: any = useRef(); //monitor api calls

   const StartLockTimmer = () => {
      timer.current = setTimeout(() => {
         //console.log('Timmed Out');
         //Timed out
         LockTheScreen();
      }, delayTime);
   };

   const LockTheScreen = () => {
      setAnim('fast fadeIn');
      setLockScreen(true);
      //clear the waiting timmer
      clearTimeout(timer.current);
   };

   const stillActive = () => {
      const activeStatus = getItemStore('AUTOMEDSYS_ISACTIVE').toString();
      if (activeStatus === '1') {
         //console.log(getItemStore('AUTOMEDSYS_ISACTIVE'));
         //api call done
         //clear the current waiting lock screen timmer
         if (timer.current) clearTimeout(timer.current);
         //set a new waiting lock screen timmer
         /* timer.current = setTimeout(() => {
            //console.log('Timmed Out');
            //Timed out
            setAnim('fast fadeIn');
            setLockScreen(true);
            //clear the waiting timmer
            clearTimeout(timer.current);
         }, delayTime); */
         StartLockTimmer();
         //reset global status
         setItemStore('AUTOMEDSYS_ISACTIVE', '0');
      }

      //force the screen to lock
      if (getItemStore('AUTOMEDSYS_ISACTIVE') === 'force') {
         LockTheScreen();
      }

      //force lockscreen

      // console.log('Set: ' + timer.current);
   };

   useEffect(() => {
      //stillActive();
      //Start Monitoring
      //StartLockTimmer();
      monitorTimer.current = setInterval(stillActive, 200);
      return () => {
         clearTimeout(timer.current);
         clearInterval(monitorTimer.current);
      };
   }, []);
   /************************************************* */

   return (
      <>
         <LockScreen
            UserName={user.name}
            Lock={lockScreen}
            setLock={setLockScreen}
            Image={Img}
            setActive={stillActive}
            anim={anim}
            setAnim={setAnim}
         />
         <div className={classes.root}>
            <Header
               sidebarIsOpened={isDesktop ? sidebarIsOpened : mobileSidebarIsOpened}
               onClick={openSidebar}
               searchFilters={searchFilters}
               user={user}
            />
            <Sidebar
               open={isDesktop ? sidebarIsOpened : mobileSidebarIsOpened}
               onClose={closeSidebar}
               variant={isDesktop}
            />
            <main className={props.removePadding ? classes.noPadcontent : classes.content}>
               <div className={classes.toolbar} />
               <AuthenticatedRoutes {...props} />
            </main>
         </div>
      </>
   );
};

export default AuthenticatedLayout;
